import { DEBUG, IS_PROD } from './validation/helpers'

export const acquiredSdk = (() => {
    if (!window.acquiredData || !window.acquiredData.publicKey) {
        // DEBUG && console.error('Missing required publicKey in acquiredData.')
        return null
    }
    try {
        return new Acquired(window.acquiredData.publicKey)
    } catch (error) {
        DEBUG && console.error('Failed to initialize Acquired SDK:', error)
        return null
    }
})()

function getOptions() {
    if (!window.acquiredData || !window.acquiredData.sessionId) {
        DEBUG && console.error('Missing required sessionId in acquiredData.')
        return {}
    }
    return {
        session: window.acquiredData.sessionId,
        environment: IS_PROD ? 'production' : 'test', // TODO Less hardcoded solution
    }
}

export const confirmParams = (() => {
    if (!window.acquiredData) {
        return {}
    }

    return {
        payment: { create_card: true },
    }
})()

export const components = acquiredSdk?.components(getOptions())
